
const urlBase = process.env.NODE_ENV === "development" ? 'https://localhost:44324':"/api";

export default urlBase
